var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isTag)?_c('el-tag',{attrs:{"type":_vm.tagType,"size":"mini"},domProps:{"textContent":_vm._s(_vm.text)}}):_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }